/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'enveloppe': {
    width: 27,
    height: 18,
    viewBox: '0 0 27 18',
    data: '<path pid="0" class="st0" d="M26.5 1.1C26.5.5 26 0 25.4 0H1.1C.5 0 0 .5 0 1.1v15.5c0 .6.5 1.1 1.1 1.1h24.4c.6 0 1.1-.5 1.1-1.1v-14-.2-.2l-.1-1.1zm-24 1h21.4L13.3 9.9 2.5 2.1zm21.9 2.7v10.9H2.1V4.8l10.5 7.5c.4.3.9.3 1.2 0l10.6-7.5z"/>'
  }
})
